import React from 'react'
import { HippostdHtml } from './HippostdHtml.jsx'
import { CtiBlogParagraph } from './CtiBlogParagraph.jsx'
import { CtiVideoCompound } from './CtiVideoCompound.jsx'
import { CtiImageCompound } from './CtiImageCompound.jsx'
import { BlogArticleWhitePaper } from '../../blogArticleWhitePaper/BlogArticleWhitePaper.jsx'
import { BlogArticleVideos } from '../../blogArticleVideos/BlogArticleVideos.jsx'
import { BlogQuote } from '../../blogQuote/BlogQuote.jsx'
import { BlogStatsAndColumns } from '../../blogStatsAndColumns/BlogStatsAndColumns.jsx'

const getByContentType = (key, el) => {
  switch (el.contentType) {
    case 'cti:VideoCompound':
      return (
        <CtiVideoCompound
          key={key}
          id={el.id}
          contentType={el.contentType}
          classNames="u-marginBottom6gu u-sizeConstrained u-sizeConstrainedNarrow"
        />
      )
    case 'hippostd:html':
      return (
        <HippostdHtml
          key={key}
          value={el.value}
          classNames="u-marginBottom6gu u-sizeConstrained u-sizeConstrainedNarrow "
        />
      )
    case 'cti:BlogParagraph':
      return (
        <CtiBlogParagraph
          key={key}
          paragraphTitle={el.paragraphTitle}
          paragraphHTML={el.paragraphHTML}
          paragraphLinks={el.paragraphLinks}
          classNames={`u-marginBottom6gu u-sizeConstrained u-sizeConstrainedNarrow${
            el.printHidden ? ' u-printHidden' : ''
          }`}
        />
      )
    case 'cti:ImageCompound':
      return (
        <CtiImageCompound
          key={key}
          {...el}
          classNames="u-marginBottom6gu u-sizeConstrained u-sizeConstrainedNarrow"
          imgClasses="u-sizeFull u-paddingVert2gu"
        />
      )
    case 'cti:CTIBlogVideoList': {
      const { ctiblogVideo = [] } = el
      return <BlogArticleVideos key={key} videoList={ctiblogVideo} />
    }
    case 'cti:CTIBlogQuote': {
      const { quote = '' } = el
      return quote ? <BlogQuote key={key} {...el} /> : null
    }
    case 'cti:CTIBlogWhitePaper': {
      const {
        title,
        overline,
        html: { value: content } = {},
        imageUrl,
        linkHref,
        link: { text: linkText, asButton } = {},
      } = el

      return (
        <BlogArticleWhitePaper
          key={key}
          content={content}
          title={title}
          linkText={linkText}
          overline={overline}
          imageUrl={imageUrl}
          alt={''}
          linkHref={linkHref}
          asButton={asButton}
        />
      )
    }
    case 'cti:CTIBlogStats':
    case 'cti:CTIBlogColumns': {
      const data = getFormattedDataToRenderStatsAndColumns(el)
      return <BlogStatsAndColumns key={key} data={data} />
    }
    default:
      return null
  }
}

function getFormattedDataToRenderStatsAndColumns({
  ctiBlogStat: stats = [],
  ctiBlogColumn: columns = [],
  contentType = '',
}) {
  const data = contentType === 'cti:CTIBlogStats' ? stats : columns
  /*
   * Formatting data to below format for easy readability
   * {contentType, title, description, image (ImageCompound), links ([LinkCompound]) }
   * */
  const formattedData = data.map((item) => {
    const { contentType = '' } = item
    if (contentType === 'cti:CTIBlogColumn') {
      const {
        contentType,
        columnTitle = {},
        columnDescription = {},
        columnImage = undefined,
        columnLink = [],
      } = item
      return {
        contentType,
        title: columnTitle,
        description: columnDescription,
        image: columnImage,
        links: columnLink,
      }
    } else {
      const {
        contentType,
        statNumber = '',
        statDescription = '',
        statImage = undefined,
      } = item
      return {
        contentType,
        title: statNumber,
        description: statDescription,
        image: statImage,
      }
    }
  })
  return formattedData
}

export const CtiBody = ({ body }) => {
  return (
    <div className="CtiBlogBody u-decoBackgroundWhite u-paddingVert12gu">
      <div id="is-blogdetail-04"></div>
      <div className="u-posRelative u-sizeConstrained u-sizeConstrainedNarrow">
        <div className="u-md-posRight" data-interaction-studio="IS010-1"></div>
      </div>
      {body.map((el, index) => {
        return getByContentType(index, el)
      })}
    </div>
  )
}
